import React, { useEffect, useState } from "react"
import styles from "./index.module.less"
import LOADING from "./loading.svg"

interface IProps {
  showLoading?: boolean
  isloading?: boolean | undefined
  children?: any
}

const Loading: React.FC<IProps> = (props) => {
  const { children, isloading = false, showLoading = false } = props
  const [show, setShow] = useState<boolean>(showLoading)
  useEffect(() => {
    let timer = setTimeout(() => {
      setShow(true)
    }, 800)
    return () => clearTimeout(timer)
  }, [])
  return (
    <>
      <div
        style={{ display: show && isloading ? "" : "none" }}
        className={styles.wrap}
      >
        <div>
          <div>
            <img src={LOADING} alt="正在加载..." title="正在加载" />
          </div>
          <div>正在请求数据，精彩即将呈现</div>
        </div>
      </div>
      <div style={{ display: isloading ? "none" : "" }}>{children}</div>
    </>
  )
}

export default Loading
